import { css } from 'styled-components';

import { Color } from '.';
import { Size as BorderSize, Radius } from './Border';
import * as BaseColor from './Color';
import * as BaseSizes from './Size';
import { Size } from './Spacing';

export const Tile = {
  Spacing: {
    XSmall: Size.XXSmall,
    Small: Size.XXSmall,
  },
};

export const Folder = {
  Button: {
    Type: 'outline',
  },
  IconWrapper: 'folder---46',
  FolderStyle: 'icon',
  Color: {
    Background: BaseColor.System.Primary,
    Title: BaseColor.Neutrals.Dark,
    Subtitle: BaseColor.NeutralsFixed.Gray,
  },
};

export const PopupMenu = {
  Button: {
    Size: BaseSizes.X6Large,
  },
};

export const Empty = {
  Icon: 'empty-box---113',
  Margin: {
    Size: {
      Medium: Size.MediumLarge,
    },
  },
};

export const Pro = {
  Icon: 'crown---gold',
};

export const QrCode = {
  Badge: {
    Pro: Pro.Icon,
    Size: 'XSmall',
  },
  Size: {
    Height: 136,
    Width: 160,
  },
};

export const Tabs = {
  Inactive: {
    BorderSize: BorderSize.Small,
  },
  Margin: {
    Bottom: Size.Small,
  },
};

export const Alert = {
  Info: {
    Icon: 'info-circle---16',
    Border: {
      Size: Radius.Medium,
      Color: BaseColor.Feedback.InfoSpecial,
    },
    Element: BaseColor.NeutralsFixed.Paper,
  },
};

export const AiLogo = {
  Header: {
    Icon: 'chevron---left',
    Angle: 0,
  },
  Button: {
    Submit: 'row',
  },
};

export const AiImage = {
  Header: {
    Icon: {},
  },
};

export const Skeleton = {
  Color: {
    Dark: 'rgba(0, 0, 0, 0.06)',
    Light: 'rgba(0, 0, 0, 0.15)',
  },
  Animation: {
    Gradient: {
      Start: 25,
      Center: 37,
      End: 63,
    },
    Background: 400,
  },
};

export const ToolBar = {
  wrapperSize: 368,
  contentContainer: 280,
  drawerGap: 72,
  navigationGap: BaseSizes.Small,
  sidePadding: BaseSizes.Small,
  blockPadding: BaseSizes.Large,
};

export const Section = {
  Effects: {
    Icons: {
      Highlight: 'effect-highlight---48',
      Underline: 'effect-underline---48',
      LineThrough: 'effect-line-through---48',
      Stroke: 'effects-stroke---48',
    },
  },
};
export const Background = Color.Neutrals.Light;

export const Logo = {
  Color: BaseColor.Brand.Darkest,
  Size: BaseSizes.X2Large,
};

export const Tooltip = {
  Color: {
    Background: BaseColor.Neutrals.Surface,
    Text: BaseColor.Neutrals.Text,
  },
};

export const Panel = {
  Background: BaseColor.Neutrals.Paper,
  BackgroundHover: BaseColor.Neutrals.Light,
  Divider: {
    Color: BaseColor.Neutrals.Light,
  },
  Height: 50,
};

export const AiAssistant = {
  Background: css`
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    background-color: rgba(255, 255, 255, 0.16);
    border: ${BorderSize.Small} solid ${BaseColor.Neutrals.Border};
  `,

  Fullscreen: {
    Cards: {
      Size: 150,
    },
    ChatHistory: {
      Container: {
        Mobile: {
          Size: '100vh - 165px',
        },
        Size: '100vh - 95px',
      },
    },
    Footer: {
      Size: 256,
    },
    Header: {
      Size: 304,
    },

    Overview: {
      Container: {
        Size: '100vh - 85px',
      },
    },
  },
};

export const Ai = {
  Overview: {
    Background: BaseColor.Neutrals.Light,
  },
  Tools: {
    Background: BaseColor.Neutrals.Dark,
  },
  ChatBubble: {
    Background: BaseColor.Neutrals.Light,
  },
  NewAIChat: {
    Disabled: BaseColor.NeutralsFixed.Border,
  },
};

export const Spin = {
  Round: {
    Size: 3,
  },
};

export const Duration = {
  Notification: 3000,
};
